import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const FeaturedDishes = () => {
  const dishes = [
    {
      name: "Special Biryani",
      description: "Aromatic rice with tender meat and special spices",
      price: "$14.99",
      image: "/lovable-uploads/d763dc92-f537-4196-8ee0-09d7ea17e1f9.png"
    },
    {
      name: "Grilled Chicken",
      description: "Perfectly seasoned and grilled to perfection",
      price: "$16.99",
      image: "/lovable-uploads/d763dc92-f537-4196-8ee0-09d7ea17e1f9.png"
    },
    {
      name: "Spicy Chickpeas",
      description: "Flavorful chickpeas in aromatic spices",
      price: "$12.99",
      image: "/lovable-uploads/d763dc92-f537-4196-8ee0-09d7ea17e1f9.png"
    }
  ];

  return (
    <div className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Our Signature Dishes
          </h2>
          <p className="text-lg text-gray-300">
            Discover our most popular and delicious offerings
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {dishes.map((dish, index) => (
            <Card key={index} className="bg-[#ea384c] text-white border-none overflow-hidden hover:shadow-lg transition-shadow">
              <img src={dish.image} alt={dish.name} className="w-full h-48 object-cover" />
              <CardContent className="p-6">
                <h3 className="text-xl font-semibold mb-2">{dish.name}</h3>
                <p className="text-gray-200 mb-4">{dish.description}</p>
                <div className="flex justify-between items-center">
                  <span className="font-bold">{dish.price}</span>
                  <Button variant="secondary" className="bg-white text-[#ea384c] hover:bg-white/90">
                    Order Now
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturedDishes;